<template>
    <div>
        <pagina-construccion
        nombreApartado="Disposiciones CONAC"
        :enlace="urlServe+'informacion-interes/armonizacion-contable/doctos-aprobados.asp'"
        ></pagina-construccion>
    </div>
</template>
<script>
import paginaConstruccion from './../../Construccion.vue'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        paginaConstruccion
    }
    
}
</script>